/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type GetCardAccountTransactionsStatus = typeof GetCardAccountTransactionsStatus[keyof typeof GetCardAccountTransactionsStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardAccountTransactionsStatus = {
  declined: 'declined',
  pending: 'pending',
  posted: 'posted',
  void: 'void',
} as const;
